import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({ endPoint: 'ProcessingAgencyQuota/Create', method: 'POST', body: body, token: token })
}
